// import React, { useMemo, useState, useCallback } from 'react';
// import PropTypes from 'prop-types';
// import {
//     MenuItem,
//     Select,
//     FormControl,
//     ListSubheader,
//     InputAdornment,
//     TextField,
//     Box,
//     Typography,
//     Divider,
//     CircularProgress
// } from '@mui/material';
// import {
//     Search as SearchIcon,
//     Add as AddIcon,
//     FolderOpen as FolderOpenIcon,
//     Category as CategoryIcon,
//     Close as CloseIcon
// } from '@mui/icons-material';

// export default function AccGroupSelect({
//     groups = [],
//     value = '',
//     onChange = () => { },
//     onAddNew = () => { },
//     placeholder = '— Select Account Group —',
//     disabled = false,
//     loading = false
// }) {
//     const [searchQuery, setSearchQuery] = useState('');
//     const [open, setOpen] = useState(false);

//     // ✅ BUILD GROUPED STRUCTURE - Match children by SubGrpName to parent GrpName
//     const grouped = useMemo(() => {
//         const parentMap = new Map();

//         // First pass: Create parent map from primary items (PrimaryNo = 1)
//         groups.forEach(g => {
//             if (Number(g.PrimaryNo) === 1) {
//                 const parentId = String(g.AccGrpID);
//                 parentMap.set(parentId, {
//                     parent: g,
//                     children: []
//                 });
//             }
//         });

//         // Second pass: Add child items (PrimaryNo = 0) to their parent
//         // ✅ FIXED: Match by SubGrpName instead of UnderGRP
//         groups.forEach(g => {
//             if (Number(g.PrimaryNo) !== 1) {
//                 // Find parent by matching child's SubGrpName with parent's GrpName
//                 const parent = groups.find(p =>
//                     Number(p.PrimaryNo) === 1 &&
//                     p.GrpName === g.SubGrpName
//                 );

//                 if (parent) {
//                     const parentId = String(parent.AccGrpID);
//                     if (parentMap.has(parentId)) {
//                         parentMap.get(parentId).children.push(g);
//                     }
//                 }
//             }
//         });

//         // Convert to array and filter out empty groups
//         return Array.from(parentMap.values());
//     }, [groups]);

//     // Filter based on search query - only filters children, not headers
//     const filteredGrouped = useMemo(() => {
//         if (!searchQuery.trim()) return grouped;

//         const query = searchQuery.toLowerCase();
//         return grouped
//             .map(group => ({
//                 ...group,
//                 children: group.children.filter(c =>
//                     c.GrpName.toLowerCase().includes(query)
//                 )
//             }))
//             .filter(group => group.children.length > 0); // Only show groups with matching children
//     }, [grouped, searchQuery]);

//     // ✅ Ensure value is always a string
//     const selectValue = value ? String(value) : '';

//     // ✅ Find selected group from all groups (not just filtered)
//     const selectedGroup = groups.find(g => String(g.AccGrpID) === selectValue);

//     // ✅ Check if the selected value exists in the groups
//     const isValidSelection = selectValue && groups.some(g => String(g.AccGrpID) === selectValue);

//     const handleChange = useCallback((e) => {
//         const val = e.target.value;

//         if (val === '__add__') {
//             onAddNew();
//             setOpen(false);
//             return;
//         }

//         if (val === '') {
//             onChange('', null);
//             setOpen(false);
//             return;
//         }

//         const selected = groups.find(g => String(g.AccGrpID) === val);

//         // ✅ Always pass string value
//         onChange(String(val), selected?.GrpName ?? null);
//         setOpen(false);
//     }, [groups, onChange]);

//     const handleSearchChange = useCallback((e) => {
//         setSearchQuery(e.target.value);
//     }, []);

//     return (
//         <FormControl fullWidth size="small" disabled={disabled || loading}>
//             <Select
//                 value={isValidSelection ? selectValue : ''}
//                 onChange={handleChange}
//                 displayEmpty
//                 open={open}
//                 onOpen={() => setOpen(true)}
//                 onClose={() => {
//                     setOpen(false);
//                     setSearchQuery('');
//                 }}
//                 renderValue={(selected) => {
//                     if (!selected || selected === '') {
//                         return (
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                 <CategoryIcon sx={{ fontSize: '1.2rem', color: '#999' }} />
//                                 <Typography sx={{ color: '#999', fontSize: '0.95rem' }}>
//                                     {placeholder}
//                                 </Typography>
//                             </Box>
//                         );
//                     }
//                     return (
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                             {selectedGroup?.PrimaryNo === 1 ? (
//                                 <FolderOpenIcon sx={{ fontSize: '1.2rem', color: '#ff9800' }} />
//                             ) : (
//                                 <CategoryIcon sx={{ fontSize: '1.2rem', color: '#2196f3' }} />
//                             )}
//                             <Typography sx={{ fontSize: '0.95rem', fontWeight: 500 }}>
//                                 {selectedGroup?.GrpName || placeholder}
//                             </Typography>
//                         </Box>
//                     );
//                 }}
//                 sx={{
//                     height: 38,
//                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                     '& .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#ddd',
//                         transition: 'border-color 0.3s'
//                     },
//                     '&:hover .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#2196f3',
//                         boxShadow: '0 0 0 2px rgba(33, 150, 243, 0.1)'
//                     },
//                     '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#1976d2',
//                         borderWidth: '2px',
//                         boxShadow: '0 0 0 4px rgba(25, 118, 210, 0.1)'
//                     },
//                     '&.Mui-disabled': {
//                         backgroundColor: '#f5f5f5',
//                         cursor: 'not-allowed'
//                     },
//                     '& .MuiSelect-icon': {
//                         transition: 'transform 0.3s'
//                     },
//                     '&.Mui-focused .MuiSelect-icon': {
//                         transform: 'rotate(180deg)'
//                     }
//                 }}
//                 MenuProps={{
//                     PaperProps: {
//                         sx: {
//                             borderRadius: '8px',
//                             marginTop: '8px',
//                             boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
//                             '&::-webkit-scrollbar': {
//                                 width: '8px'
//                             },
//                             '&::-webkit-scrollbar-track': {
//                                 backgroundColor: 'transparent'
//                             },
//                             '&::-webkit-scrollbar-thumb': {
//                                 backgroundColor: '#bbb',
//                                 borderRadius: '4px',
//                                 '&:hover': {
//                                     backgroundColor: '#999'
//                                 }
//                             },
//                             maxHeight: '400px'
//                         }
//                     },
//                     MenuListProps: {
//                         sx: {
//                             py: 1,
//                             '& .MuiMenuItem-root': {
//                                 transition: 'all 0.2s'
//                             }
//                         }
//                     }
//                 }}
//             >
//                 {/* Placeholder */}
//                 <MenuItem value="" disabled sx={{ display: 'none' }}>
//                     {placeholder}
//                 </MenuItem>

//                 {/* Search Box */}
//                 <Box
//                     sx={{
//                         p: 1.5,
//                         display: 'flex',
//                         gap: 1,
//                         position: 'sticky',
//                         top: 0,
//                         backgroundColor: '#fff',
//                         borderBottom: '1px solid #eee',
//                         zIndex: 1000
//                     }}
//                     onClick={(e) => e.stopPropagation()}
//                     onMouseDown={(e) => e.stopPropagation()}
//                     onKeyDown={(e) => e.stopPropagation()}
//                 >
//                     <TextField
//                         autoFocus
//                         size="small"
//                         placeholder="Search groups..."
//                         value={searchQuery}
//                         onChange={handleSearchChange}
//                         fullWidth
//                         onKeyDown={(e) => e.stopPropagation()}
//                         InputProps={{
//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <SearchIcon sx={{ fontSize: '1.2rem', color: '#999' }} />
//                                 </InputAdornment>
//                             ),
//                             endAdornment: searchQuery && (
//                                 <InputAdornment position="end">
//                                     <CloseIcon
//                                         sx={{
//                                             fontSize: '1.2rem',
//                                             color: '#999',
//                                             cursor: 'pointer',
//                                             '&:hover': { color: '#333' }
//                                         }}
//                                         onClick={() => setSearchQuery('')}
//                                     />
//                                 </InputAdornment>
//                             )
//                         }}
//                         sx={{
//                             '& .MuiOutlinedInput-root': {
//                                 height: '36px',
//                                 borderRadius: '6px',
//                                 backgroundColor: '#f8f8f8'
//                             }
//                         }}
//                     />
//                 </Box>

//                 {/* Loading state */}
//                 {loading && (
//                     <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
//                         <CircularProgress size={24} />
//                     </Box>
//                 )}

//                 {/* No results */}
//                 {!loading && filteredGrouped.length === 0 && searchQuery.trim() && (
//                     <MenuItem disabled sx={{ justifyContent: 'center', py: 2 }}>
//                         <Typography sx={{ color: '#999', fontSize: '0.9rem' }}>
//                             No groups found
//                         </Typography>
//                     </MenuItem>
//                 )}

//                 {/* No groups at all */}
//                 {!loading && grouped.length === 0 && !searchQuery.trim() && (
//                     <MenuItem disabled sx={{ justifyContent: 'center', py: 2 }}>
//                         <Typography sx={{ color: '#999', fontSize: '0.9rem' }}>
//                             No groups available
//                         </Typography>
//                     </MenuItem>
//                 )}

//                 {/* Render grouped items - Only children are selectable, parents as headers */}
//                 {!loading && filteredGrouped.length > 0 && filteredGrouped.map(({ parent, children }) => [
//                     // Category Header - Shows parent name (PrimaryNo = 1)
//                     <ListSubheader
//                         key={`header-${parent.AccGrpID}`}
//                         sx={{
//                             backgroundColor: 'linear-gradient(135deg, #f5f5f5 0%, #fafafa 100%)',
//                             fontWeight: 700,
//                             color: '#333',
//                             fontSize: '0.85rem',
//                             lineHeight: '40px',
//                             paddingLeft: '16px',
//                             textTransform: 'uppercase',
//                             letterSpacing: '0.5px',
//                             borderBottom: '1px solid #eee',
//                             marginTop: '4px',
//                             cursor: 'default',
//                             userSelect: 'none'
//                         }}
//                     >
//                         <FolderOpenIcon sx={{ mr: 1, fontSize: '1rem', mb: -0.3, color: '#ff9800' }} />
//                         {parent.GrpName}
//                     </ListSubheader>,

//                     // Child Items (PrimaryNo = 0) - These are selectable
//                     ...children.map((c, idx) => (
//                         <MenuItem
//                             key={`child-${parent.AccGrpID}-${c.AccGrpID}-${idx}`}
//                             value={String(c.AccGrpID)}
//                             sx={{
//                                 paddingLeft: '56px',
//                                 fontSize: '0.9rem',
//                                 color: '#666',
//                                 transition: 'all 0.2s',
//                                 position: 'relative',
//                                 '&::before': {
//                                     content: '"└"',
//                                     position: 'absolute',
//                                     left: '40px',
//                                     color: '#ddd',
//                                     fontWeight: 'bold'
//                                 },
//                                 '&:hover': {
//                                     backgroundColor: '#e3f2fd',
//                                     pl: '64px',
//                                     color: '#1976d2',
//                                     fontWeight: 500
//                                 },
//                                 '&.Mui-selected': {
//                                     backgroundColor: '#e3f2fd',
//                                     color: '#0d47a1',
//                                     fontWeight: 600
//                                 }
//                             }}
//                         >
//                             {c.GrpName}
//                         </MenuItem>
//                     ))
//                 ])}

//                 {/* Divider */}
//                 {!loading && filteredGrouped.length > 0 && (
//                     <Divider sx={{ my: 0.5, borderColor: '#f0f0f0' }} />
//                 )}

//                 {/* Add new group */}
//                 {!loading && (
//                     <MenuItem
//                         value="__add__"
//                         sx={{
//                             paddingLeft: '16px',
//                             color: '#1976d2',
//                             fontWeight: 600,
//                             fontSize: '0.95rem',
//                             transition: 'all 0.2s',
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: 1,
//                             '&:hover': {
//                                 backgroundColor: '#e3f2fd',
//                                 pl: '24px'
//                             }
//                         }}
//                     >
//                         <AddIcon sx={{ fontSize: '1.2rem' }} />
//                         Add New Group
//                     </MenuItem>
//                 )}
//             </Select>
//         </FormControl>
//     );
// }

// AccGroupSelect.propTypes = {
//     groups: PropTypes.array,
//     value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//     onChange: PropTypes.func,
//     onAddNew: PropTypes.func,
//     placeholder: PropTypes.string,
//     disabled: PropTypes.bool,
//     loading: PropTypes.bool
// };





import React, { useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
    MenuItem,
    Select,
    FormControl,
    ListSubheader,
    InputAdornment,
    TextField,
    Box,
    Typography,
    Divider,
    CircularProgress,
    FormHelperText,    // ✅ Add
    InputLabel
} from '@mui/material';
import {
    Search as SearchIcon,
    Add as AddIcon,
    FolderOpen as FolderOpenIcon,
    Category as CategoryIcon,
    Close as CloseIcon
} from '@mui/icons-material';

export default function AccGroupSelect({
    groups = [],
    value = '',
    onChange = () => { },
    onAddNew = () => { },
    placeholder = '— Select Account Group —',
    disabled = false,
    loading = false,
    required = false,      // ✅ Add
    error = false,         // ✅ Add
    helperText = ''
}) {
    const [searchQuery, setSearchQuery] = useState('');
    const [open, setOpen] = useState(false);

    const filteredGroups = useMemo(() => {
        let result = groups;

        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase();
            // result = groups.filter(g =>
            //     g.GrpName?.toLowerCase().includes(query)
            // );
            result = groups.filter(g =>
                g.GrpName?.toLowerCase().includes(query) ||
                g.SubGrpName?.toLowerCase().includes(query)
            );
        }

        // ✅ SORT BY NAME (A → Z)
        return result.sort((a, b) =>
            // (a.GrpName || '').localeCompare(b.GrpName || '')
            (a.SubGrpName || a.GrpName || '').localeCompare(b.SubGrpName || b.GrpName || '')
        );

    }, [groups, searchQuery]);

    // ✅ Ensure value is always a string
    const selectValue = value ? String(value) : '';

    // ✅ Find selected group from all groups (not just filtered)
    const selectedGroup = groups.find(g => String(g.AccGrpID) === selectValue);

    // ✅ Check if the selected value exists in the groups
    const isValidSelection = selectValue && groups.some(g => String(g.AccGrpID) === selectValue);

    const handleChange = useCallback((e) => {
        const val = e.target.value;

        if (val === '__add__') {
            onAddNew();
            setOpen(false);
            return;
        }

        if (val === '') {
            onChange('', null);
            setOpen(false);
            return;
        }

        const selected = groups.find(g => String(g.AccGrpID) === val);

        // ✅ Always pass string value
        // onChange(String(val), selected?.GrpName ?? null);
        onChange(String(val), selected?.SubGrpName ?? selected?.GrpName ?? null);
        setOpen(false);
    }, [groups, onChange]);

    const handleSearchChange = useCallback((e) => {
        setSearchQuery(e.target.value);
    }, []);

    return (
        <FormControl fullWidth size="small" disabled={disabled || loading} error={error} required={required}>
            <Select
                value={isValidSelection ? selectValue : ''}
                onChange={handleChange}
                displayEmpty
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => {
                    setOpen(false);
                    setSearchQuery('');
                }}
                renderValue={(selected) => {
                    if (!selected || selected === '') {
                        return (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <CategoryIcon sx={{ fontSize: '1.2rem', color: '#999' }} />
                                <Typography sx={{ color: '#999', fontSize: '0.95rem' }}>
                                    {placeholder} {required && <span style={{ color: 'red' }}>*</span>}
                                </Typography>
                            </Box>
                        );
                    }
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {selectedGroup?.IsPrimary === 1 ? (
                                <FolderOpenIcon sx={{ fontSize: '1.2rem', color: '#ff9800' }} />
                            ) : (
                                <CategoryIcon sx={{ fontSize: '1.2rem', color: '#2196f3' }} />
                            )}
                            {/* <Typography sx={{ fontSize: '0.95rem', fontWeight: 500 }}>
                                {selectedGroup?.GrpName || placeholder}
                            </Typography> */}
                            <Typography sx={{ fontSize: '0.95rem', fontWeight: 500 }}>
                                {selectedGroup
                                    ? `${selectedGroup.SubGrpName || selectedGroup.GrpName || ''}${selectedGroup.GrpName && selectedGroup.SubGrpName ? ` [${selectedGroup.GrpName}]` : ''}`
                                    : placeholder}
                            </Typography>
                        </Box>
                    );
                }}
                sx={{
                    height: 38,
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: error ? '#d32f2f' : '#ddd',  // ✅ Update
                        transition: 'border-color 0.3s'
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: error ? '#d32f2f' : '#2196f3',  // ✅ Update
                        boxShadow: error ? '0 0 0 2px rgba(211, 47, 47, 0.1)' : '0 0 0 2px rgba(33, 150, 243, 0.1)'  // ✅ Update
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: error ? '#d32f2f' : '#1976d2',  // ✅ Update
                        borderWidth: '2px',
                        boxShadow: error ? '0 0 0 4px rgba(211, 47, 47, 0.1)' : '0 0 0 4px rgba(25, 118, 210, 0.1)'  // ✅ Update
                    },
                    '&.Mui-disabled': {
                        backgroundColor: '#f5f5f5',
                        cursor: 'not-allowed'
                    },
                    '& .MuiSelect-icon': {
                        transition: 'transform 0.3s'
                    },
                    '&.Mui-focused .MuiSelect-icon': {
                        transform: 'rotate(180deg)'
                    }
                }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            borderRadius: '8px',
                            marginTop: '8px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                            '&::-webkit-scrollbar': {
                                width: '8px'
                            },
                            '&::-webkit-scrollbar-track': {
                                backgroundColor: 'transparent'
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#bbb',
                                borderRadius: '4px',
                                '&:hover': {
                                    backgroundColor: '#999'
                                }
                            },
                            maxHeight: '400px'
                        }
                    },
                    MenuListProps: {
                        sx: {
                            py: 1,
                            '& .MuiMenuItem-root': {
                                transition: 'all 0.2s'
                            }
                        }
                    }
                }}
            >
                {/* Placeholder */}
                <MenuItem value="" disabled sx={{ display: 'none' }}>
                    {placeholder}
                </MenuItem>

                {/* Search Box */}
                <Box
                    muiSkipListHighlight
                    sx={{
                        p: 1.5,
                        display: 'flex',
                        gap: 1,
                        position: 'sticky',
                        top: 0,
                        backgroundColor: '#fff',
                        borderBottom: '1px solid #eee',
                        zIndex: 1000
                    }}
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                >
                    <TextField
                        size="small"
                        placeholder="Search groups..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        fullWidth
                        onKeyDown={(e) => e.stopPropagation()}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon sx={{ fontSize: '1.2rem', color: '#999' }} />
                                </InputAdornment>
                            ),
                            endAdornment: searchQuery && (
                                <InputAdornment position="end">
                                    <CloseIcon
                                        sx={{
                                            fontSize: '1.2rem',
                                            color: '#999',
                                            cursor: 'pointer',
                                            '&:hover': { color: '#333' }
                                        }}
                                        onClick={() => setSearchQuery('')}
                                    />
                                </InputAdornment>
                            )
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                height: '36px',
                                borderRadius: '6px',
                                backgroundColor: '#f8f8f8'
                            }
                        }}
                    />
                </Box>

                {/* Loading state */}
                {loading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                        <CircularProgress size={24} />
                    </Box>
                )}

                {/* No results */}
                {!loading && filteredGroups.length === 0 && searchQuery.trim() && (
                    <MenuItem disabled sx={{ justifyContent: 'center', py: 2 }}>
                        <Typography sx={{ color: '#999', fontSize: '0.9rem' }}>
                            No groups found
                        </Typography>
                    </MenuItem>
                )}

                {/* No groups at all */}
                {!loading && groups.length === 0 && !searchQuery.trim() && (
                    <MenuItem disabled sx={{ justifyContent: 'center', py: 2 }}>
                        <Typography sx={{ color: '#999', fontSize: '0.9rem' }}>
                            No groups available
                        </Typography>
                    </MenuItem>
                )}

                {/* Render grouped items - Only children are selectable, parents as headers */}
                {!loading && filteredGroups.length > 0 && filteredGroups.map((g) => (
                    <MenuItem
                        key={g.AccGrpID}
                        value={String(g.AccGrpID)}
                        sx={{
                            fontSize: '0.9rem',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            pl: Number(g.IsPrimary) === 1 ? 2 : 4,
                            fontWeight: Number(g.IsPrimary) === 1 ? 600 : 400,
                            color: Number(g.IsPrimary) === 1 ? '#000' : '#666',
                            '&:hover': {
                                backgroundColor: '#e3f2fd'
                            },
                            '&.Mui-selected': {
                                backgroundColor: '#e3f2fd',
                                fontWeight: 600
                            }
                        }}
                    >
                        {Number(g.IsPrimary) === 1 ? (
                            <FolderOpenIcon sx={{ fontSize: '1rem', color: '#ff9800' }} />
                        ) : (
                            <CategoryIcon sx={{ fontSize: '1rem', color: '#2196f3' }} />
                        )}
                        {/* {g.GrpName} */}
                        {/* {g.GrpName} {g.SubGrpName ? `[${g.SubGrpName}]` : ''} */}
                        {g.SubGrpName || g.GrpName} {g.SubGrpName && g.GrpName ? `[${g.GrpName}]` : ''}
                    </MenuItem>
                ))}

                {/* Divider */}
                {!loading && filteredGroups.length > 0 && (
                    <Divider sx={{ my: 0.5, borderColor: '#f0f0f0' }} />
                )}

                {/* Add new group */}
                {!loading && (
                    <MenuItem
                        value="__add__"
                        sx={{
                            paddingLeft: '16px',
                            color: '#1976d2',
                            fontWeight: 600,
                            fontSize: '0.95rem',
                            transition: 'all 0.2s',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            '&:hover': {
                                backgroundColor: '#e3f2fd',
                                pl: '24px'
                            }
                        }}
                    >
                        <AddIcon sx={{ fontSize: '1.2rem' }} />
                        Add New Group
                    </MenuItem>
                )}
            </Select>
            {helperText && (
                <FormHelperText>{helperText}</FormHelperText>
            )}
        </FormControl>
    );
}

AccGroupSelect.propTypes = {
    groups: PropTypes.array,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    onAddNew: PropTypes.func,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    required: PropTypes.bool,     // ✅ Add
    error: PropTypes.bool,        // ✅ Add
    helperText: PropTypes.string
};